import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'
import { store } from './store/store'
import ElementUI from 'element-ui';
//import '../theme/index.css'
import locale from 'element-ui/lib/locale/lang/es'

import GlobalComponents from './globalComponents'
import VueCompositionAPI from '@vue/composition-api'
import VueMask from 'v-mask'

Vue.use(ElementUI, { locale })
Vue.use(GlobalComponents)
Vue.use(VueCompositionAPI)
Vue.use(VueMask)

Vue.config.productionTip = false

// navigation guards before each
router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.requiresAuth)) {
		if (localStorage.getItem('accessToken') === null) {
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			})
		} else {
      next()
      window.scroll(0, 0)
		}
	} else {
		next() // make sure to always call next()!
    window.scroll(0, 0)
	}
})

axios.defaults.baseURL = 'https://api.eventsonline.app'
axios.defaults.headers.common = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

Vue.mixin({
	data() {
		return {
        
      }
    },
    computed: {
        
    },
    methods: {
    addMinutesToTime(time, minsAdd) {
        function z(n){ return (n<10? '0':'') + n;};
        var bits = time.split(':');
        var mins = bits[0]*60 + +bits[1] + +minsAdd;
        return z(mins%(24*60)/60 | 0) + ':' + z(mins%60);
    }, 
      formatCurrency(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
        //let localeInfo = this.$store.getters.getUserauthResponse
          let localeInfo = localeInfo1.locale_info
          if(formatCurrency) {
              
              var n = value, 
              c = localeInfo.decimal_allowed ? 2 : 0, 
              d = localeInfo.decimal_separator, 
              t = localeInfo.thousand_separator, 
              s = n < 0 ? "-" : "", 
              i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
              j = (j = i.length) > 3 ? j % 3 : 0;
              

              if(localeInfo.decimal_allowed) {
                  return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
              } else {
                  return localeInfo.currency_symbol+" "+s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
              }
              
            
          } else {
              return (value).toFixed(localeInfo.maxFraction)
          }
    },
    formatCurrencyNoPrefix(value, formatCurrency = true, localeInfo1 = this.$store.getters.getUserauthResponse) {
        //let localeInfo = this.$store.getters.getUserauthResponse
          let localeInfo = localeInfo1.locale_info
          if(formatCurrency) {
            
              var n = value, 
              c = localeInfo.max_fraction, 
              d = localeInfo.decimal_separator, 
              t = localeInfo.thousand_separator, 
              s = n < 0 ? "-" : "", 
              i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
              j = (j = i.length) > 3 ? j % 3 : 0;
              
              if(localeInfo.max_fraction>0) {
                  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
              } else {
                  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t);
              }
              
            
          } else {
              return (value).toFixed(localeInfo.maxFraction)
          }
    },
    changeDate(value, $offset = false) {

        var monthNames = [
            'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
        ];
        
        let date = new Date(value)
        if($offset) {
            date = new Date( date.getTime() + Math.abs(date.getTimezoneOffset()*60000) )
        }

        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        
        if(day<10) {
            day = "0"+day
        }
        return day + ' ' + monthNames[monthIndex] + ' ' + year;

    },
    changeDateTime(value) {

        return this.changeDate(value)+', '+value.substring(value.indexOf(' '))   

    },
    changeTime(value) {

        let date = new Date(value)
        
        var hour = date.getHours();
        var minutes = date.getMinutes();
        
        if(hour<10) {
            hour = "0"+hour
        }
        if(minutes<10) {
            minutes = "0"+minutes
        }
        return hour + ':' + minutes;

    },
    isNumber(evt) {
        console.log(evt)
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
        } else {
            return true;
        }
},
    numberToSpanish(n, custom_join_character) {

        var string = n.toString(),
            units, tens, scales, start, end, chunks, chunksLen, chunk, ints, i, word, words;
    
        var and = custom_join_character || ' ';
    
        /* Is number zero? */
        if (parseInt(string) === 0) {
            return 'cero';
        }
    
        /* Array of units as words */
        units = ['', 'uno', 'dos', 'tres', 'cuatro', 'cinco', 'seis', 'siete', 'ocho', 'nueve', 'diez', 'once', 'doce', 'trece', 'catorce', 'quince', 'dieciséis', 'diecisiete', 'dieciocho', 'diecinueve'];
    
        /* Array of tens as words */
        tens = ['', '', 'veinte', 'treinta', 'cuarenta', 'cincuenta', 'sesenta', 'setenta', 'ochenta', 'noventa'];
    
        /* Array of scales as words */
        scales = ['', 'mil', 'millón', 'mil millones', 'trillón', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quatttuor-decillion', 'quindecillion', 'sexdecillion', 'septen-decillion', 'octodecillion', 'novemdecillion', 'vigintillion', 'centillion'];
    
        /* Split user arguemnt into 3 digit chunks from right to left */
        start = string.length;
        chunks = [];
        while (start > 0) {
            end = start;
            chunks.push(string.slice((start = Math.max(0, start - 3)), end));
        }
    
        /* Check if function has enough scale words to be able to stringify the user argument */
        chunksLen = chunks.length;
        if (chunksLen > scales.length) {
            return '';
        }
    
        /* Stringify each integer in each chunk */
        words = [];
        for (i = 0; i < chunksLen; i++) {
    
            chunk = parseInt(chunks[i]);
    
            if (chunk) {
    
                /* Split chunk into array of individual integers */
                ints = chunks[i].split('').reverse().map(parseFloat);
    
                /* If tens integer is 1, i.e. 10, then add 10 to units integer */
                if (ints[1] === 1) {
                    ints[0] += 10;
                }
    
                /* Add scale word if chunk is not zero and array item exists */
                if ((word = scales[i])) {
                    words.push(word);
                }
    
                /* Add unit word if array item exists */
                if ((word = units[ints[0]])) {
                    words.push(word);
                }
    
                /* Add tens word if array item exists */
                if ((word = tens[ints[1]])) {
                    words.push(word);
                }
    
                /* Add 'and' string after units or tens integer if: */
                if (ints[0] || ints[1]) {
    
                    /* Chunk has a hundreds integer or chunk is the first of multiple chunks */
                    if (ints[2] || !i && chunksLen) {
                        words.push(and);
                    }
    
                }
    
                /* Add hundreds word if array item exists */
                if ((word = units[ints[2]])) {
                    words.push(word + ' centenar');
                }
    
            }
    
        }
    
        return words.reverse().join(' ');
    
    }
		
    }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js